export enum PickupStatus {
  in_progress = 'In Progress',
  attempted = 'Attempted',
  completed = 'Completed',
  cancelled = 'Cancelled',
  missed = 'Missed',
}
